/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Open_Screen_Plan_WeekInputs */

const en_us2_chat_open_screen_plan_week = /** @type {(inputs: Chat_Open_Screen_Plan_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open my week`)
};

const pt_br2_chat_open_screen_plan_week = /** @type {(inputs: Chat_Open_Screen_Plan_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir minha semana`)
};

const es_419_chat_open_screen_plan_week = /** @type {(inputs: Chat_Open_Screen_Plan_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir mi semana`)
};

const pt_pt2_chat_open_screen_plan_week = /** @type {(inputs: Chat_Open_Screen_Plan_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir a minha semana`)
};

const fr_fr2_chat_open_screen_plan_week = /** @type {(inputs: Chat_Open_Screen_Plan_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir ma semaine`)
};

const de_de2_chat_open_screen_plan_week = /** @type {(inputs: Chat_Open_Screen_Plan_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Woche öffnen`)
};

const it_it2_chat_open_screen_plan_week = /** @type {(inputs: Chat_Open_Screen_Plan_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri la mia settimana`)
};

/**
* | output |
* | --- |
* | "Open my week" |
*
* @param {Chat_Open_Screen_Plan_WeekInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const chat_open_screen_plan_week = /** @type {((inputs?: Chat_Open_Screen_Plan_WeekInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Open_Screen_Plan_WeekInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_chat_open_screen_plan_week(inputs)
	if (locale === "es-419") return es_419_chat_open_screen_plan_week(inputs)
	if (locale === "pt-PT") return pt_pt2_chat_open_screen_plan_week(inputs)
	if (locale === "fr-FR") return fr_fr2_chat_open_screen_plan_week(inputs)
	if (locale === "de-DE") return de_de2_chat_open_screen_plan_week(inputs)
	if (locale === "it-IT") return it_it2_chat_open_screen_plan_week(inputs)
	return en_us2_chat_open_screen_plan_week(inputs)
});
export { chat_open_screen_plan_week as "chat.open_screen.plan_week" }